import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
// import { NotificationsService } from 'app/layout/common/notifications/notifications.service';  // ✅ REMOVED: No longer needed in resolver
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin } from 'rxjs';

export const initialDataResolver = () =>
{
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    // const notificationsService = inject(NotificationsService);  // ✅ REMOVED: Now using SharedAlertsCacheService
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    // ✅ OPTIMIZATION: Removed notificationsService.getAll() - notifications now load via SharedAlertsCacheService
    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
        // notificationsService.getAll(),  // ✅ REMOVED to eliminate duplicate API call
        quickChatService.getChats(),
        shortcutsService.getAll(),
    ]);
};
